import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Container, Grid2, Stack, Typography } from '@mui/material';
import { PointOfSale, QrCodeScanner, ReceiptLong } from '@mui/icons-material';
import Navbar from '../../setup/Navbar';

export default function BakeryPOS() {
  const navigate = useNavigate();
  const actions = [
    { title: 'Forward Invoice', text: 'Salesman customer ke liye unpaid token banaye.', icon: <ReceiptLong fontSize="large" />, route: '/BakeryForwardInvoice' },
    { title: 'Cash Counter', text: 'Forward invoice scan karein ya direct sale banayein.', icon: <QrCodeScanner fontSize="large" />, route: '/BakeryCashCounter' },
  ];
  return (
    <>
      <Navbar />
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 3 }}>
          <PointOfSale color="primary" fontSize="large" />
          <Box><Typography variant="h4" fontWeight={800}>Bakery POS</Typography><Typography color="text.secondary">Salesman aur Cash Counter workflow</Typography></Box>
        </Stack>
        <Grid2 container spacing={2}>
          {actions.map((action) => (
            <Grid2 size={{ xs: 12, md: 6 }} key={action.route}>
              <Card variant="outlined" sx={{ height: '100%' }}>
                <CardContent>
                  {action.icon}
                  <Typography variant="h5" fontWeight={700} sx={{ mt: 1 }}>{action.title}</Typography>
                  <Typography color="text.secondary" sx={{ my: 2 }}>{action.text}</Typography>
                  <Button variant="contained" onClick={() => navigate(action.route)}>Open {action.title}</Button>
                </CardContent>
              </Card>
            </Grid2>
          ))}
        </Grid2>
      </Container>
    </>
  );
}
